import { render } from "./LinkageLogin.vue?vue&type=template&id=260da812&scoped=true&ts=true"
import script from "./LinkageLogin.vue?vue&type=script&lang=ts"
export * from "./LinkageLogin.vue?vue&type=script&lang=ts"

import "./LinkageLogin.vue?vue&type=style&index=0&id=260da812&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1488180328/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260da812"]])

export default __exports__